<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 lg6 offset-lg3>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 lg6 offset-lg3>
        <h1>Reset Password</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4>
        <v-form @submit.prevent="submit">
          <v-text-field
            v-model="email"
            label="Email Address"
            required
            id="email"
          />
          <v-btn
            block
            type="submit"
            id="submit"
            :loading="isLoading"
            :disabled="isLoading"
          >
            Email Reset Instructions
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: '',
    isLoading: false,

    isError: false,
    errMessage: null
  }),
  methods: {
    submit () {
      // Try to initiate a password reset
      this.isLoading = true
      this.axios.post('/auth/passwordreset/request', {
        email: this.email
      })
        .then(() => {
          // If we had success, redirect the user to where they'll be able to
          // use the token they've been emailed
          this.$router.push('/forgot/finish')
        })
        .catch(this.$root.apiErrorHandler((msg, errors) => {
          this.isLoading = false
          this.errMessage = errors['email'] || msg
          this.isError = true
        }))
    }
  }
}
</script>
